// // import React from "react";
// import { useDispatch, useSelector } from "react-redux";
// import React, { useEffect, useRef, useState } from "react";
// import Form from "components/Layout/Form";
// import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
// import { NotificationContainer, NotificationManager } from 'react-notifications';
// import { setToken } from "store/setToken/action";

// import { setLoading } from "store/setLoading/action";
// import { verificationEmail } from "service";




// const Index = () => {
//     const state = useSelector((state) => state);
//     const dispatch = useDispatch()
//     const [show, setShow] = useState(true);
//     const { email, ref } = useParams();
//     const handleClose = () => setShow(false);
//     const history = useHistory();
//     const submitlogin = async (values) => {
//         if (!email) {
//             NotificationManager.warning("have'nt a email")
//             return;
//         }
//         dispatch(setLoading(true));

//         const res = await verificationEmail(email, values.verificationCode);
//         console.log('====================================');
//         console.log("resres", res);
//         console.log('====================================');
//         if (res?.code === 200) {
//             history.push(`/setpass/${email}/${res.data.token}/${ref}`)

//         } else {
//             if (res?.message) {
//                 NotificationManager.warning(res?.message)
//             } else {
//                 NotificationManager.warning("fail")
//             }

//         }
//         dispatch(setLoading(false));

//     }

//     return (
//         <>
//             <section className="apply-area">
//                 <div className="container">
//                     <div className="row align-items-center justify-content-center">
//                         <div className="col-12">
//                             <div className="apply-form card_luffy no-hover">
//                                 {/* Intro */}
//                                 <div className="text-main-color d-flex justify-content-center align-items-end mb-4 ">
//                                     <span className="intro-text font_LNTH-Lissaindidone text-title text-main-color">Vertification</span>
//                                 </div>

//                                 <Form action="#" onFinish={submitlogin} className="form form-register">
//                                     <div className="form-group">

//                                         <input type="text" className="slslslldawdge" id="verificationCode" name="verificationCode" placeholder="verificationCode" />

//                                     </div>
//                                     <div className="form-group mt-4">
//                                         <button type="submit" className="btn  active btn-submit font_LNTH-Lissaindidone">Confirm</button>
//                                     </div>

//                                 </Form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default Index;





import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import Loading from "./../components/LoadingError/Loading";
import { checkRef, register, verificationEmail } from "../service";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";


const Register = ({ location, history }) => {
    window.scrollTo(0, 0);
    // const [name, setName] = useState("");
    // const [email, setEmail] = useState("");
    // const [password, setPassword] = useState("");
    const [code, setCode] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { email, ref } = useParams();

    // const dispatch = useDispatch();
    const redirect = location.search ? location.search.split("="[1]) : "/";

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!email) {
            setError(`have'nt a email`)
            // NotificationManager.warning("have'nt a email")
            return;
        }
        setLoading(true)

        const res = await verificationEmail(email, code);
        console.log('====================================');
        console.log("resres", res);
        console.log('====================================');
        if (res?.code === 200) {
            history.push(`/setpass/${email}/${res.data.token}/${ref}`)

        } else {
            if (res?.message) {
                // NotificationManager.warning(res?.message)
                setError(res?.message)
            } else {
                setError('fail')
                // NotificationManager.warning("fail")
            }

        }
        setLoading(false)

        // setLoading(true)
        // const resRef = await checkRef(ref);

        // if (resRef.code === 200) {
        //     const res = await register(email);
        //     if (res?.code === 200) {
        //         history.push(`/verification-mail/${email}/${ref}`)
        //     } else {
        //         if (res?.message) {
        //             setError(res?.message)
        //         } else {
        //             setError('fail')
        //         }

        //     }
        // } else {
        //     if (resRef?.message) {
        //         setError(resRef?.message)
        //     } else {
        //         setError('fail')
        //     }
        // }
        // setLoading(false)
    }

    // useEffect(() => {
    //     const url = window.location.href;
    //     const lastSlashIndex = url.lastIndexOf("/");
    //     const addressWithRefId = url.substring(lastSlashIndex + 1);
    //     const [address, queryString] = addressWithRefId.split("?");
    //     const params = new URLSearchParams(queryString);
    //     const refId = params.get("ref");
    //     setRef(refId);
    //     return () => {
    //     };
    // }, []);

    return (
        <>
            <Header />
            <div className="container d-flex flex-column justify-content-center align-items-center login-center">
                {error && <Message variant="alert-info">{error}</Message>}
                {loading && <Loading />}
                <form
                    className="Login col-md-8 col-lg-4 col-11"
                    onSubmit={submitHandler}
                >
                    <input type="text" value={code} className="slslslldawdge" id="verificationCode" name="verificationCode" placeholder="verificationCode" onChange={(e) => { setCode(e.target.value) }} />
                    {/* <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Ref"
                        value={ref}
                        onChange={(e) => setRef(e.target.value)}
                    /> */}

                    <button type="submit">Đăng ký
                    </button>
                    <p>
                        <Link to={redirect ? `/login?redirect=${redirect}` : "/login"}>
                            Tôi có tài khoản
                            <strong>Đăng nhập
                            </strong>
                        </Link>
                    </p>
                </form>
            </div>
        </>
    );
};

export default Register;

